import { isBefore, isAfter } from 'date-fns'
import { IOrderItem } from '../../model/order.store'
import { sumBy, head } from 'lodash'
import {
  getValentineGiftSkusMap,
  listFatherDaySkus,
  listFatherDayGiftSkus,
  listMotherDay2026CakeSkus,
  listMotherDay2026GiftSkus,
  listFatherDay2026CakeSkus,
  listFatherDay2026GiftSkus,
  ValentineGiftType,
  valentineSkusMap,
  teacherDaySkus
} from '../skus.utils'
import { getDeliverĐeadline, getSubTOtalWithoutPricedGift } from './discount-utils'

/**
 * File chứa các chương trình khuyến mãi ngắn hạn (short-term)
 * - Valentine, Father's Day, Teacher's Day...
 * - Các chương trình có thời gian áp dụng cụ thể và kết thúc trong năm
 */

// ============================================
// VALENTINE GIFT - 08/01 đến 15/02/2025
// ============================================
export function checkAndGetValidGiftValentine(
  items: IOrderItem[],
  onlineOrder: any,
  giftType: ValentineGiftType
) {
  const deliverDeadline = getDeliverĐeadline(onlineOrder)

  const validGiftingSaleSkus = valentineSkusMap[giftType as keyof typeof valentineSkusMap]
  let giftText = ''
  let saleProgram = ''
  const giftSku = head(getValentineGiftSkusMap()[giftType])
  if (giftType === 'mica') {
    giftText = `${giftSku} Que cắm Valentine mica Forever Love`
    saleProgram = 'Tặng que cắm Valentine mica Forever Love'
  }

  if (giftType === 'card') {
    giftText = `${giftSku} Thiệp Valentine (mẫu ngẫu nhiên)`
    saleProgram = 'Tặng thiệp Valentine (mẫu ngẫu nhiên)'
  }

  let byQtyDiscountAvailNum = sumBy(items, item => {
    if (validGiftingSaleSkus.includes(item.sku)) {
      return item.quantity
    }
    return 0
  })

  return {
    isValid:
      isAfter(deliverDeadline, new Date('2025-01-08T00:00:00+07:00')) &&
      isBefore(deliverDeadline, new Date('2025-02-15T00:00:00+07:00')) &&
      byQtyDiscountAvailNum >= 1,
    giftNum: byQtyDiscountAvailNum,
    giftText,
    giftSku,
    saleProgram
  }
}

// ============================================
// SET QUÀ TẾT
// ============================================
export function isSetQuaTetItem(item: IOrderItem) {
  return [
    'B13019',
    'B13020',
    'B13021',
    'B13022',
    'B13023',
    'B13024',
    'B13025',
    'B13026',
    'B13027',
    'B13028',
    'B13029',
    'B13030',
    'B13031',
    'B13032',
    'B13033',
    'B13034',
    'B13035',
    'B13036',
    'B13037',
    'B13038',
    'B13039',
    'B13040',
    'B13041',
    'B13042',
    'B13043',
    'B13044',
    'B13045',
    'B13046',
    'B13047',
    'B13048',
    'B13049'
  ].includes(item.sku)
}

// ============================================
// FATHER'S DAY GIFT - 09/06 đến 16/06/2025
// ============================================
export function checkAndGetValidFatherDayGift(
  items: IOrderItem[],
  onlineOrder: any,
  outletCode: string
) {
  const deliverDeadline = getDeliverĐeadline(onlineOrder)
  const giftSku = head(listFatherDayGiftSkus)

  let giftText = `${giftSku} Que mica Love You papa`
  let saleProgram = 'Tặng que mica Love You papa'

  let isValidOrder = false
  const validByMenuItemsCount = sumBy(items, item => {
    if (listFatherDaySkus.includes(item.sku)) {
      return item.quantity
    }
    return 0
  })
  if (validByMenuItemsCount >= 1) {
    isValidOrder = true
  }
  if (!isValidOrder) {
    isValidOrder = getSubTOtalWithoutPricedGift(items, 'SAVOR_SHOP', 'SHOP') >= 300000
  }

  return {
    isValid:
      isAfter(deliverDeadline, new Date('2025-06-09T00:00:00+07:00')) &&
      isBefore(deliverDeadline, new Date('2025-06-16T00:00:00+07:00')) &&
      isValidOrder &&
      outletCode.match(/B\d+/i) &&
      outletCode !== 'B8',
    giftNum: validByMenuItemsCount,
    giftText,
    giftSku,
    saleProgram
  }
}

// ============================================
// TEACHER'S DAY GIFT - 14/11 đến 21/11/2025
// ============================================
export function checkAndGetValidTeacherDayGift(items: IOrderItem[], onlineOrder: any) {
  const deliverDeadline = getDeliverĐeadline(onlineOrder)

  const autoGiftSku = 'V9262' // que mica Teacher Day

  let byQtyDiscountAvailNum = sumBy(items, item => {
    if (teacherDaySkus.includes(item.sku)) {
      return item.quantity
    }
    return 0
  })

  return {
    isValid:
      isAfter(deliverDeadline, new Date('2025-11-14T00:00:00+07:00')) &&
      isBefore(deliverDeadline, new Date('2025-11-21T00:00:00+07:00')) &&
      byQtyDiscountAvailNum >= 1,
    giftQuantity: byQtyDiscountAvailNum,
    giftSku: autoGiftSku,
    saleProgram: 'Tặng que cắm mica Teacher Day',
    giftText: `${autoGiftSku} Que mica Happy Teacher's Day`
  }
}

// ============================================
// MOTHER'S DAY GIFT 2026 - 02/05 đến 10/05/2026
// Tặng V1443 (Que cắm Love you mom) cho mỗi bánh menu Ngày Của Mẹ
// ============================================
export function checkAndGetValidMotherDay2026Gift(items: IOrderItem[], onlineOrder: any) {
  const deliverDeadline = getDeliverĐeadline(onlineOrder)
  const giftSku = head(listMotherDay2026GiftSkus)

  const giftText = `${giftSku} Que cắm Love you mom`
  const saleProgram = 'Tặng Que cắm Love you mom Ngày Của Mẹ'

  const validByMenuItemsCount = sumBy(items, item => {
    if (listMotherDay2026CakeSkus.includes(item.sku)) {
      return item.quantity
    }
    return 0
  })

  return {
    isValid:
      isAfter(deliverDeadline, new Date('2026-05-02T00:00:00+07:00')) &&
      isBefore(deliverDeadline, new Date('2026-05-10T23:59:59+07:00')) &&
      validByMenuItemsCount >= 1,
    giftNum: validByMenuItemsCount,
    giftText,
    giftSku,
    saleProgram
  }
}

// ============================================
// Tặng V8728 (Que cắm My Dad is My Hero) cho mỗi bánh menu Ngày Của Cha
// ============================================
export function checkAndGetValidFatherDay2026Gift(items: IOrderItem[], onlineOrder: any) {
  const deliverDeadline = getDeliverĐeadline(onlineOrder)
  const giftSku = head(listFatherDay2026GiftSkus)

  const giftText = `${giftSku} Que cắm My Dad is My Hero`
  const saleProgram = 'Tặng Que cắm Ngày của Cha'

  const validByMenuItemsCount = sumBy(items, item => {
    if (listFatherDay2026CakeSkus.includes(item.sku)) {
      return item.quantity
    }
    return 0
  })

  return {
    isValid:
      isAfter(deliverDeadline, new Date('2026-06-16T00:00:00+07:00')) &&
      isBefore(deliverDeadline, new Date('2026-06-21T23:59:59+07:00')) &&
      validByMenuItemsCount >= 1,
    giftNum: validByMenuItemsCount,
    giftText,
    giftSku,
    saleProgram
  }
}
